import css from './card-skeletons.module.css';

/**
 * Placeholder cards while a list is fetched — after a client-side navigation
 * the page has no build-time seed, so its list loads from Supabase. Shown
 * instead of the empty state, which would flash "coming soon" for a list
 * that isn't empty at all. Hidden from screen readers.
 */
export function CardSkeletons({ count = 3 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={css.card} aria-hidden="true">
          <div className={css.photo} />
          <div className={css.line} />
          <div className={css.line} />
        </div>
      ))}
    </>
  );
}
